import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit
} from '@angular/core';
//import { RouterLinkActive } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
//import { MenuItems } from '../../../shared/menu-items/menu-items';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { InstiMenu } from '../../../insti/instiMenu';
import { ActivatedRoute, Router } from '@angular/router';
import { instiRoutehandle } from '../../../insti/instiRoutehandle.module';
import { InstiHelpers } from '../../../insti/instihelpers.module';
import { BaseOrcService } from '../../../natureza51/sistema-orcamentario/base-orc.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;
  params;
  link_terceiros;
  nivel;
  tipo_user;

  private _mobileQueryListener: () => void;
  status: boolean = true;
  
  itemSelect:number[]=[]
  private menus:InstiMenu[]=[];
  subclickEvent() {
    this.status = true;
  }
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    // public menuItems: MenuItems,
   protected insti_route?:instiRoutehandle,
   protected service?:BaseOrcService,
   private router?: Router
  ) {
  

    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    
    
    this.menus=[ (new InstiMenu()).load(environment.main_menu_id,this.service),
                  // (new InstiMenu()).load(2,this.service)
                ];    
 
  } 
    
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  /**
   * @Author: ALUISIO FERREIRA DE SOUSA - 25022020 atmmaster36@yahoo.com.br
   * @param ARRAY|STRING menuitem_state obrigatorio é esperado um array indexado com strings que representam os fragmentos da url(state) ou apenas a string,
   * @param ARRAY|STRING childitem_state? opcional vide o paramento menuitem_state 
   * @param ARRAY|STRING child_state?  opcional vide o paramento menuitem_state
   * @return ARRAY indexado
   */
  getRouterLinkByState(p_menuitem_state:string,p_childitem_state?:string, p_child_state?:string){
    
     let helpers=new InstiHelpers();     
      
     let separeteUrl=function(url){
         return helpers.empty(p_menuitem_state)? [] : p_menuitem_state.split('/');
    }
     let menuitem_state:string[]=separeteUrl(p_menuitem_state);
     let retorno:string[]=['/'].concat(menuitem_state);
     
     if(helpers.empty(p_childitem_state)){
         return retorno;
     }
     let child=this.getRouterLinkByState(p_childitem_state);
         child.splice(0,1);
      
     retorno=retorno.concat(child);
     
     if(helpers.empty(p_child_state)){
        return retorno;
     }
     let sub_child=this.getRouterLinkByState(p_child_state);
     sub_child.splice(0,1);
    
    //  console.log("aquiiiiii dfgsdfgsdfgsdfg");
     retorno=retorno.concat(sub_child);
     return retorno;
       
       //['/', menuitem.state]
  }
  getGroupName(p_menuitem):string{
      let helpers=new InstiHelpers();
      if(helpers.empty(p_menuitem)){
          return '';
      }
      return p_menuitem.hasOwnProperty('group_name') ? p_menuitem.group_name : '';
  }
  setSelected(i, j){    
    
      //let selectedId=0;
      /** let heroes:any= this.route.paramMap.pipe(
      switchMap(params => {
        // (+) before `params.get()` turns the string into a number
        //this.selectedId = +params.get('id');
        return 36;
      })
    );
      */
      this.itemSelect[i]=j;
      return this.itemSelect[i];
      // (click)="setSelected(i,j)"
  }

  protected getMenus(){
    return this.menus;
}
protected isType(menu_item, tipo){
    if(!menu_item){
      return false;
    }
    if("undefined" === typeof(menu_item['isType'])){
      return false;
    }
    try{
    return menu_item.isType(tipo);
    }
    catch(err){
      console.log(err);
      return false;
    }
}

  protected getNivelUser(){
    let data_user = this.service.getUserData();
    return this.nivel = data_user.nivel_hier;
  }

  protected getTipoUser(){
    let data_user = this.service.getUserData();
     return this.tipo_user = data_user.tipo_user;
  }

  link(form_data,success,error, link){
      return this.service.doHttp(`${link}`,'post',success,error,form_data, null, true);
  }

  goToLinkExt(childitem){
    this.link_terceiros = childitem.state;
    let data_user = this.service.getUserData();
   
    const data = { usuarioNome: data_user.nome_funcionario,
    usuarioEmail: data_user.email,
    usuarioID: data_user.cdn_funcionario,
    usuarioLogin: data_user.email.split("@")[0]};
   
     this.params = JSON.stringify(data);    
    // console.log({data_user});
    setTimeout(function (){ 
      var formTerceiros = document.getElementById("formTerceiros"); 
      var botaoSubmit = document.getElementById("btnSubmit")
      botaoSubmit.click();
      let metodo = 'submit';
      formTerceiros[metodo]();
    }, 1000);   
   
    }

}
